import React, { useState } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

interface WizardSessionDialogProps {
  title: string;
  headerTitle: string;
  message?: string;
  onClose: (agreed: boolean, title: string) => void;
}

function WizardSessionDialog(props: WizardSessionDialogProps) {
  const [title, setTitle] = useState(props.title);

  return (
    <Dialog
      open
      fullWidth
      maxWidth="xs"
      aria-labelledby="wizard-session-dialog-title"
      aria-describedby="wizard-session-dialog-description"
    >
      <DialogTitle id="wizard-session-dialog-title">
        {props.headerTitle}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="wizard-session-dialog-description">
          {props.message}
        </DialogContentText>
        <TextField
          variant="standard"
          label="Title"
          value={title}
          fullWidth
          onChange={(e) => setTitle(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            props.onClose(false, title);
          }}
          color="primary"
        >
          Cancel
        </Button>
        <Button
          disabled={title.trim() === ''}
          onClick={() => {
            props.onClose(true, title.trim());
          }}
          color="primary"
          autoFocus
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default WizardSessionDialog;
